var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniDirection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 8,
    viewBox: "0 0 38 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333333 3.68945C0.333333 5.16221 1.52724 6.35612 3 6.35612C4.47276 6.35612 5.66667 5.16221 5.66667 3.68945C5.66667 2.21669 4.47276 1.02279 3 1.02279C1.52724 1.02279 0.333333 2.21669 0.333333 3.68945ZM37.3536 4.04301C37.5488 3.84774 37.5488 3.53116 37.3536 3.3359L34.1716 0.153919C33.9763 -0.041343 33.6597 -0.041343 33.4645 0.153919C33.2692 0.349181 33.2692 0.665764 33.4645 0.861026L36.2929 3.68945L33.4645 6.51788C33.2692 6.71314 33.2692 7.02972 33.4645 7.22499C33.6597 7.42025 33.9763 7.42025 34.1716 7.22499L37.3536 4.04301ZM3 3.68945V4.18945H37V3.68945V3.18945H3V3.68945Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniDirection);
export default __webpack_public_path__ + "static/media/uni-direction.ea95684355589a8117d0f95ff0db6b5f.svg";
export { ForwardRef as ReactComponent };